export * from './IconCheckBadgeGradient';
export { default as IconCheckBadgeGradient } from './IconCheckBadgeGradient';
